module.exports = __webpack_public_path__ + "img/grocery.6725b248.jpg";